import { render } from "./SkillAuthoringChat.vue?vue&type=template&id=c852387a&scoped=true"
import script from "./SkillAuthoringChat.vue?vue&type=script&lang=js"
export * from "./SkillAuthoringChat.vue?vue&type=script&lang=js"

import "./SkillAuthoringChat.vue?vue&type=style&index=0&id=c852387a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c852387a"]])

export default __exports__